import ActionTypes from "../enums/ActionTypes"

interface State {
  newMessageTempId: number
}

interface Action {
  type: string
  payload: {
    id: number
  }
}

const initialState: State = {
  newMessageTempId: null,
}

export default (state: State = initialState, action: Action) => {
  if (action.type === ActionTypes.SOCKET_RECEIVED_MESSAGE) {
    return {
      ...state,
      newMessageTempId: action.payload,
    }
  }
  return state
}
